import { render, staticRenderFns } from "./PwaNotification.vue?vue&type=template&id=cc195094"
import script from "./PwaNotification.vue?vue&type=script&lang=ts"
export * from "./PwaNotification.vue?vue&type=script&lang=ts"
import style0 from "./PwaNotification.vue?vue&type=style&index=0&id=cc195094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports